import { NavLink, useNavigate } from "react-router-dom";
import { useApp } from "../context/AppContext";
import { SYLLAPLUS_LOGO_B64 } from "../constants";

const NAVY = "var(--navy)";
const SIDEBAR_W = 220;

const NAV_ITEMS = [
  { to: "/app/files", label: "My Files", icon: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"/></svg>
  )},
  { to: "/app/drive", label: "Google Drive", icon: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M7.71 3.5L1.15 15l3.43 5.5h13.84l3.43-5.5-6.56-11.5H7.71zm.57 1h7.44l5.7 10H2.58l5.7-10zM5.01 16h13.98l-2.5 4H7.51l-2.5-4z"/></svg>
  )},
  { to: "/app/studio", label: "Syllabus Studio", icon: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M12 20h9"/><path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z"/></svg>
  )},
  { to: "/app/calendar", label: "Calendar", icon: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
  )},
  { to: "/app/groups", label: "Groups", icon: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>
  )},
];

export default function Sidebar() {
  const { driveConnected, pendingInvites } = useApp();
  const navigate = useNavigate();

  return (
    <div style={{ width: SIDEBAR_W, minWidth: SIDEBAR_W, height: "100vh", background: NAVY, display: "flex", flexDirection: "column", position: "fixed", left: 0, top: 0, zIndex: 40 }}>

      {/* Logo */}
      <div style={{ padding: "20px 20px 16px", borderBottom: "1px solid rgba(255,255,255,0.08)" }}>
        <div style={{ display: "flex", alignItems: "center", gap: "10px", cursor: "pointer" }} onClick={() => navigate("/")}>
          <img src={`data:image/png;base64,${SYLLAPLUS_LOGO_B64}`} alt="SyllaPlus" style={{ width: "30px", height: "30px" }} />
          <span style={{ fontSize: "16px", fontWeight: "600", color: "white", letterSpacing: "-0.3px" }}>SyllaPlus</span>
        </div>
      </div>

      {/* Nav items */}
      <nav style={{ flex: 1, padding: "12px 10px", display: "flex", flexDirection: "column", gap: "2px" }}>
        {NAV_ITEMS.map(item => (
          <NavLink key={item.to} to={item.to} style={({ isActive }) => ({
            display: "flex", alignItems: "center", gap: "10px",
            padding: "9px 12px", borderRadius: "8px", textDecoration: "none",
            fontSize: "14px", fontWeight: "700",
            color: "white",
            background: isActive ? "rgba(255,255,255,0.12)" : "transparent",
            transition: "all 0.15s",
            position: "relative"
          })}>
            {item.icon}
            <span>{item.label}</span>
            {item.label === "Google Drive" && driveConnected && (
              <span style={{ width: "6px", height: "6px", background: "#22c55e", borderRadius: "50%", marginLeft: "auto" }} />
            )}
            {item.label === "Groups" && pendingInvites?.length > 0 && (
              <span style={{ fontSize: "10px", fontWeight: "700", color: "white", background: "#ef4444", borderRadius: "10px", padding: "1px 6px", marginLeft: "auto" }}>{pendingInvites.length}</span>
            )}
          </NavLink>
        ))}
      </nav>

      {/* Bottom: User */}
      <div style={{ padding: "10px", borderTop: "1px solid rgba(255,255,255,0.08)" }}>
        
        
      </div>
    </div>
  );
}